import React, { useState } from 'react';
import { Row, Column } from 'react-foundation';

import Input from './Inputs';

const ProfileInformation = (props) => {
	const [active, setActive] = useState(true);

	const toggle = () => {
		setActive(!active);
	};

	return (
		<>
			<button className="card accordion" onClick={toggle}>
				<div className="account-card-title">Profile information</div>
				<div className="account-card-text">
					Basic information associated with your profile
				</div>
				<div className="arrow-holder">
					<div className={active ? 'arrow active' : 'arrow'}></div>
				</div>
			</button>
			<div className={active ? 'dropdown active' : 'dropdown'}>
				<form
					className="simple_form edit_user"
					id="edit_user"
					role="form"
					novalidate="novalidate"
					enctype="multipart/form-data"
					action="/users"
					accept-charset="UTF-8"
					method="post"
				>
					<input name="utf8" type="hidden" value="✓" />
					<input type="hidden" name="_method" value="put" />
					<input
						type="hidden"
						name="authenticity_token"
						value="1HsVfR/IKH4OuFqq1hcbLMnBgqD0oA4vAk/XAu2orU5ngkS4W+KAoLfVTVbC4M1qrITieHY6yA8ySk+fWVdRhw=="
					/>

					<div className="form-group">
						<Row>
							<Column small={12} medium={6}>
								<Input inputType="first_name" />
							</Column>
							<Column small={12} medium={6}>
								<Input inputType="last_name" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="email" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="phone_number" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="linked_in_profile" />
							</Column>
						</Row>
					</div>
					<div className="form-group">
						<Row>
							<Column small={12}>
								<Input
									inputType="user_profile_image"
									backup_profile_images={
										props.backup_profile_images
									}
									imageSize={props.imageSize}
								/>
							</Column>
						</Row>
					</div>
					<div className="form-group">
						<Row>
							<Column small={12}>
								<Input inputType="has_organization" />
								<Input inputType="organization_name" />
							</Column>
						</Row>
					</div>
					<div className="form-group">
						<Row>
							<Column small={12}>
								<Input
									inputType="user_interest_areas"
									interest_areas={props.interest_areas}
								/>
							</Column>
						</Row>
					</div>
					<div className="form-group">
						<Row>
							<Column small={12}>
								<Input inputType="organization_relationship" />
							</Column>
						</Row>
						<Row>
							<Column small={12}>
								<Input inputType="title" />
							</Column>
						</Row>
					</div>
					<Row>
						<Column small={12}>
							<div className="button-holder">
								<input
									type="submit"
									name="commit"
									value="Save"
									className="primary-button long"
									data-disable-with="SAVE"
								/>
							</div>
						</Column>
					</Row>
				</form>
			</div>
		</>
	);
};

export default ProfileInformation;
